import { useEffect, useState } from "react";
import { SetChallengeToComplete } from "../redux/v2/challenge/actions"
import { useDispatch } from "react-redux";

const useMilestones = (props) => {
    const dispatch = useDispatch();

    const [milestones, setMilestones] = useState([]);
    const [current, setCurrent] = useState(null);

    useEffect(() => {
        setCurrent(null);
        let tempMilestones = props.challenge?.milestone?.split("-");

        let found = false;
        tempMilestones = tempMilestones?.map((m, i) => {
            let min = i == 0 ? 0 : (tempMilestones[i - 1] * 1);
            let max = tempMilestones[i] * 1;
            let value = props.accomplishment * 1;

            const milestone = {
                type: props.challenge?.unit,
                value: (value > max) ? max : value,
                max: max,
                min: min,
                stage: i + 1,
            };

            if (!found && value < max) {
                found = true;
                setCurrent({
                    ...milestone,
                    index: i
                });
            }


            if (i == tempMilestones.length - 1 && value >= max) {
                setCurrent({
                    ...milestone,
                    index: i,
                    isComplete: true
                });

                if (props?.challenge?.statusType == "active") {
                    // dispatch(SetChallengeToComplete(props?.challenge));
                }

            }

            return milestone;
        })

        setMilestones(tempMilestones);

    }, [props.accomplishment, props.challenge]);
    return { milestones: milestones, current: current };
}

export default useMilestones;
